import { NotFoundView } from "@/views/common/notfound.view";
import { Route, Switch } from "wouter";
import { CustomerSapExportView } from "./customer-sap-export.view";

export function CustomerSapExportRoutes() {
  return (
    <Switch>
      <Route path={"/"} component={CustomerSapExportView} />
      <Route component={NotFoundView} />
    </Switch>
  );
}
